
import { SchScheduleItem } from './index';

export class SchScheduleItemStatus {
   public scheduleItemStatusId: number = 0;
   public scheduleItemStatus: string = null;
   public schScheduleItem: SchScheduleItem[] = [];
}